import { Heart, Ship, Building2, Compass, MapPin } from "lucide-react";
import { IMAGES } from "@/lib/images";
import { PageHero, SectionHeading, FeatureGrid, CTABand } from "@/components/PageBlocks";
import { Reveal } from "@/components/Reveal";
import { useSeo } from "@/hooks/useSeo";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const TYPES = [
  { icon: Building2, title: "Beach & Resort Honeymoons", desc: "Sun, sand, and time to slow down together." },
  { icon: Ship, title: "Cruises", desc: "Wake up somewhere new without unpacking twice." },
  { icon: MapPin, title: "European & City Escapes", desc: "Food, history, and romance across iconic cities." },
  { icon: Compass, title: "Adventure & Culture", desc: "For couples who'd rather explore than lie still." },
  { icon: Heart, title: "Multi-Destination Journeys", desc: "Combine a few places into one unforgettable trip." },
];

export default function Honeymoons() {
  useSeo({ title: "Honeymoons | Inforno Travel", description: "Your honeymoon should feel like the two of you. Inforno Travel helps couples plan the destination, timing, and details that matter to them." });
  return (
    <div className="bg-noir min-h-screen">
      <Navbar />
      <PageHero overline="Honeymoons" title="The First Chapter of Forever." image={IMAGES.honeymoon}
        sub="Your honeymoon should feel like the two of you — not like someone else's package. We help you shape a trip around what you both actually want."
        primary={{ label: "Start Planning Your Honeymoon", to: "/start-your-journey" }} />

      <section className="py-24 md:py-32 px-6 md:px-12 bg-noir">
        <div className="max-w-[1500px] mx-auto">
          <div className="mb-14"><SectionHeading overline="Ways to Honeymoon" title="However you picture it" /></div>
          <FeatureGrid items={TYPES} />
        </div>
      </section>

      <section className="py-24 md:py-32 px-6 md:px-12 bg-[#0a0a0a] border-y border-white/10">
        <div className="max-w-[1500px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7"><SectionHeading overline="Planning Your Honeymoon" title="We handle the details, you enjoy each other" /></div>
          <div className="md:col-span-4 md:col-start-9">
            <Reveal delay={0.1}>
              <p className="font-body text-white/60 text-sm md:text-base leading-relaxed font-light">
                We help couples make decisions around destination, timing, budget, accommodations, experiences, and the
                little touches that matter — so your first trip as newlyweds feels easy from the start.
              </p>
            </Reveal>
          </div>
        </div>
      </section>

      <CTABand eyebrow="Congratulations" title="Let's plan a honeymoon that's truly yours." label="Start Planning Your Honeymoon" to="/start-your-journey" showRtb />
      <Footer />
    </div>
  );
}
